export default {"src":"/_next/static/media/Shipping&Delivery.7f043e99.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};